
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { createFirmEntry, fetchSingleFirm, updateFirmEntry } from '../../Store/PHPSlice/Firm';
import { useParams } from 'react-router-dom';


const FirmEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const imgUrl = process.env.REACT_APP_IMAGE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        firmId: parseInt(Id),
        firmNm: '',
        adrs: '',
        ph: '',
        emailId: '',
        pan: '',
        gst: '',
        website: '',
        bank: '',
        accNo: '',
        brnchNm: '',
        ifsc: '',
        userId: userdata?.ID,
        image: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const getSingle = useSelector((state) => state.FirmData.singleFirm || { data: [] });

    useEffect(() => {
        dispatch(fetchSingleFirm(Id));
    }, [dispatch]);

    useEffect(() => {
        if (getSingle.data.length > 0) {
            const item = getSingle.data[0];
            setFormData(prev => ({
                ...prev,
                firmNm: item.firmNm,
                adrs: item.adrs,
                ph: item.contact,
                emailId: item.emailId,
                pan: item.pan,
                gst: item.gst,
                website: item.website,
                bank: item.bankNm,
                accNo: item.ac_no,
                brnchNm: item.branchNm,
                ifsc: item.ifsc,
                image: item.firmImg,
            }));
        }
    }, [getSingle]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph' || name === 'accNo') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph' && value.length > 10) {
            return;
        }

        if (['firmNm', 'pan', 'gst', 'ifsc', 'bank', 'brnchNm'].includes(name)) {
            setFormData({ ...formData, [name]: value.toUpperCase() });
        } else {
            setFormData({ ...formData, [name]: value });
        }

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            image: e.target.files[0]
        });
    };

    // const validate = () => {
    //     const newErrors = {};
    //     if (!formData.companyName) newErrors.companyName = 'Firm Name is required';
    //     if (!formData.contactNo) {
    //         newErrors.contactNo = 'Contact is required';
    //     } else if (!/^\d{10}$/.test(formData.contactNo)) {
    //         newErrors.contactNo = 'Contact must be a 10-digit number';
    //     }
    //     if (!formData.companyType) newErrors.companyType = 'Company Type is required';
    //     if (!formData.address) newErrors.address = 'Address is required';
    //     if (formData.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) {
    //         newErrors.email = 'Invalid email address';
    //     }
    //     return newErrors;
    // };


    const handleSubmit = async (event) => {
        event.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        // console.log(formData);

        setLoading(true);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('firmId', formData.firmId);
            formDataToSend.append('firmNm', formData.firmNm);
            formDataToSend.append('adrs', formData.adrs);
            formDataToSend.append('ph', formData.ph);
            formDataToSend.append('emailId', formData.emailId);
            formDataToSend.append('pan', formData.pan);
            formDataToSend.append('gst', formData.gst);
            formDataToSend.append('website', formData.website);
            formDataToSend.append('bank', formData.bank);
            formDataToSend.append('accNo', formData.accNo);
            formDataToSend.append('brnchNm', formData.brnchNm);
            formDataToSend.append('ifsc', formData.ifsc);
            formDataToSend.append('userId', formData.userId);

            if (formData.image instanceof File) {
                formDataToSend.append('image', formData.image);
            }

            const result = await dispatch(updateFirmEntry(formDataToSend)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Firm Updated Successful");
            alert("Firm Updated Successful");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const imagePreview =
        formData.image instanceof File
            ? URL.createObjectURL(formData.image)
            : `${imgUrl}/${formData.image}`;


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement


    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Firm Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>

                            <Grid container spacing={2}>
                                {[
                                    { label: 'Firm Name', name: 'firmNm', required: true },
                                    { label: 'Email', name: 'emailId' },
                                    { label: 'Address', name: 'adrs', required: true },
                                    { label: 'Contact', name: 'ph', required: true },
                                    { label: 'Pan No', name: 'pan' },
                                    { label: 'GST No', name: 'gst' },
                                    { label: 'Bank Name', name: 'bank' },
                                    { label: 'Account No', name: 'accNo' },
                                    { label: 'Branch Name', name: 'brnchNm' },
                                    { label: 'IFSC Code', name: 'ifsc' },
                                    { label: 'WebSite', name: 'website' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='image'>Firm Header Image:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='image'
                                                    name='image'
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    inputProps={{ style: styled.inputImg }}
                                                    sx={inputImages}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.image ? <Grid item xs={12} md={6}>
                                    <p>Previous Image</p>
                                    {formData.image && (
                                        <img
                                            src={imagePreview}
                                            style={{ width: '80vw', border: '1px solid black' }}
                                            alt="Firm"
                                        />
                                    )}


                                </Grid> : null}


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default FirmEdit;
